module.exports = __webpack_public_path__ + "static/media/infoJumbo1.3f9e0887.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/ziersch/images/infoJumbo1.png
// module id = 470
// module chunks = 0